import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '名称',
        placeholder: '',
        value: '',
        rules: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-textarea',
        componentName: '输入框',
        fieldKey: 'mark',
        fieldName: '描述',
        placeholder: '',
        value: '',
        rules: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        config: {
          isDisabled: false,
          clearable: true,
          width: '100%'
        }
      }
    ]
  }
]
